import { Carousel } from "primereact/carousel"
import { Link } from "@inertiajs/react"
import ExploreBrandCard from "./ExploreBrandCard"

const responsiveOptions = [
    { breakpoint: "1400px", numVisible: 5, numScroll: 1 },
    { breakpoint: "1200px", numVisible: 4, numScroll: 1 },
    { breakpoint: "900px", numVisible: 3, numScroll: 1 },
    { breakpoint: "640px", numVisible: 2, numScroll: 1 },
    { breakpoint: "480px", numVisible: 1, numScroll: 1 },
]
export default function ExploreOtherBrands({
    brands,
    currentBrandSlug,
    max = 10,
}) {
    const items = brands
        .filter((b) => b.slug !== currentBrandSlug)
        .slice(0, max)
    if (items.length === 0) return null
    return (
        <section className="w-full px-10 py-16 mx-auto max-w-7xl">
            <h2 className="mb-8 text-xl font-bold tracking-wide text-center text-gray-900">
                POPULAR FIREARM BRANDS
            </h2>

            <Carousel
                value={items}
                numVisible={6}
                numScroll={1}
                responsiveOptions={responsiveOptions}
                itemTemplate={(brand) => <ExploreBrandCard brand={brand} />}
                showIndicators={false}
                circular
                className="explore-brands-carousel [&_.p-carousel-next]:inline-flex [&_.p-carousel-prev]:inline-flex"
            />

            <div className="flex justify-center mt-8">
                <Link
                    href="/brands"
                    className="inline-flex min-w-[240px] items-center justify-center rounded-md border border-[#800020] bg-white px-8 py-2.5 text-sm font-medium text-[#800020] transition hover:bg-[#800020]/5"
                >
                    View All Brands
                </Link>
            </div>
        </section>
    )
}
